module.exports = __webpack_public_path__ + "img/4-5.e9ae2c2a.svg";